import type { RequestExperienceEventInterface } from "@/libs/client/goApi/experience/experienceEventRecentlyViewInterface";

export function generateParamsEventExp(
  params: RequestExperienceEventInterface[],
): string[] {
  return params.map((param) => {
    return param.sportTeamSlug
      ? `${param.subCategorySlug}_${param.sportTeamSlug}`
      : param.subCategorySlug;
  });
}
